/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon16Solid = forwardRef('ArrowDCornerLeftUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.616 5.366a1.25 1.25 0 1 0 1.768 1.768L5.75 4.768V12A3.25 3.25 0 0 0 9 15.25h5.75a1.25 1.25 0 1 0 0-2.5H9a.75.75 0 0 1-.75-.75V4.768l2.366 2.366a1.25 1.25 0 0 0 1.768-1.768L8.732 1.715a2.45 2.45 0 0 0-3.464 0L1.616 5.366Z" })));
});
